/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Recyclepumps1Inputs */



/**
* | output |
* | --- |
* | "Recirculation pumps" |
*
* @param {Br_History_Key_Recyclepumps1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_recyclepumps1 = /** @type {((inputs?: Br_History_Key_Recyclepumps1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Recyclepumps1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recirculation pumps")
	return /** @type {LocalizedString} */ ("Pompes de recyclage")
});
export { br_history_key_recyclepumps1 as "br_history_key_recyclePumps" }